<script lang="ts">
  import { defineComponent } from "vue";
  import AccidentTravailCodeRisque from '@/extend/controls/accidentTravail/AccidentTravailCodeRisque';
  import AccidentTravailDateEffet from '@/extend/controls/accidentTravail/AccidentTravailDateEffet';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import AccidentTravailSource from '@/extend/controls/accidentTravail/AccidentTravailSource';
  import AccidentTravailTauxPatronal from '@/extend/controls/accidentTravail/AccidentTravailTauxPatronal';
  import AccidentTravailType from '@/extend/controls/accidentTravail/AccidentTravailType';
  import ApprentiDateDebut from '@/extend/controls/apprenti/ApprentiDateDebut';
  import ApprentiDateFin from '@/extend/controls/apprenti/ApprentiDateFin';
  import ApprentiDateRupture from '@/extend/controls/apprenti/ApprentiDateRupture';
  import ApprentiNom from '@/extend/controls/apprenti/ApprentiNom';
  import ApprentiPrenom from '@/extend/controls/apprenti/ApprentiPrenom';
  import CiviliteSelect from '@/extend/controls/civilite/CiviliteSelect';
  import AttestationDateDemande from '@/extend/controls/attestation/AttestationDateDemande';
  import AttestationDateValid from '@/extend/controls/attestation/AttestationDateValid';
  import AttestationDefSelect from '@/extend/controls/attestationDef/AttestationDefSelect';
  import AttestationMotif from '@/extend/controls/attestation/AttestationMotif';
  import AttestationStatut from '@/extend/controls/attestation/AttestationStatut';
  import EtablissementSelect from '@/extend/controls/etablissement/EtablissementSelect';
  import AuthorizedCreditCreditLimit from '@/extend/controls/authorizedCredit/AuthorizedCreditCreditLimit';
  import AuthorizedCreditCreditLimitUntil from '@/extend/controls/authorizedCredit/AuthorizedCreditCreditLimitUntil';
  import AuthorizedCreditPermanent from '@/extend/controls/authorizedCredit/AuthorizedCreditPermanent';
  import ContratEditBaseSalarie from '@/extend/controls/contrat/ContratEditBaseSalarie';
  import ContratExoEtranger from '@/extend/controls/contrat/ContratExoEtranger';
  import ContratTemplateSelect from '@/extend/controls/contratTemplate/ContratTemplateSelect';
  import ConventionClauseMiroir from '@/extend/controls/convention/ConventionClauseMiroir';
  import EmploiSelect from '@/extend/controls/emploi/EmploiSelect';
  import RubriqueSelect from '@/extend/controls/rubrique/RubriqueSelect';
  import SalarieSummary from '@/extend/controls/salarie/SalarieSummary';
  import ContratTemplateActive from '@/extend/controls/contratTemplate/ContratTemplateActive';
  import ContratTemplateName from '@/extend/controls/contratTemplate/ContratTemplateName';
  import ContratTemplateTitre from '@/extend/controls/contratTemplate/ContratTemplateTitre';
  import ContratTemplateUseConvention from '@/extend/controls/contratTemplate/ContratTemplateUseConvention';
  import ActiviteSelect from '@/extend/controls/activite/ActiviteSelect';
  import CreneauDate from '@/extend/controls/creneau/CreneauDate';
  import CreneauHeureDebut from '@/extend/controls/creneau/CreneauHeureDebut';
  import CreneauHeureFin from '@/extend/controls/creneau/CreneauHeureFin';
  import LieuSummary from '@/extend/controls/lieu/LieuSummary';
  import BrancheSelect from '@/extend/controls/branche/BrancheSelect';
  import CaisseSelectComplementaire from '@/extend/controls/caisse/CaisseSelectComplementaire';
  import ContactSelect from '@/extend/controls/contact/ContactSelect';
  import ContactSummary from '@/extend/controls/contact/ContactSummary';
  import ConventionBrancheList from '@/extend/controls/convention/ConventionBrancheList';
  import EtablissementAccordCollectif from '@/extend/controls/etablissement/EtablissementAccordCollectif';
  import EtablissementAlias from '@/extend/controls/etablissement/EtablissementAlias';
  import EtablissementBrancheCode from '@/extend/controls/etablissement/EtablissementBrancheCode';
  import EtablissementBrancheNom from '@/extend/controls/etablissement/EtablissementBrancheNom';
  import EtablissementCongesSpec from '@/extend/controls/etablissement/EtablissementCongesSpec';
  import EtablissementConventionCode from '@/extend/controls/etablissement/EtablissementConventionCode';
  import EtablissementConventionNom from '@/extend/controls/etablissement/EtablissementConventionNom';
  import EtablissementDateCreation from '@/extend/controls/etablissement/EtablissementDateCreation';
  import EtablissementFcap from '@/extend/controls/etablissement/EtablissementFcap';
  import EtablissementFnas from '@/extend/controls/etablissement/EtablissementFnas';
  import EtablissementIdentAssociation from '@/extend/controls/etablissement/EtablissementIdentAssociation';
  import EtablissementLicenceSpectacle from '@/extend/controls/etablissement/EtablissementLicenceSpectacle';
  import EtablissementLicenceStatus from '@/extend/controls/etablissement/EtablissementLicenceStatus';
  import EtablissementLicenceValidite from '@/extend/controls/etablissement/EtablissementLicenceValidite';
  import EtablissementLogo from '@/extend/controls/etablissement/EtablissementLogo';
  import EtablissementMail from '@/extend/controls/etablissement/EtablissementMail';
  import EtablissementModeFacture from '@/extend/controls/etablissement/EtablissementModeFacture';
  import EtablissementNom from '@/extend/controls/etablissement/EtablissementNom';
  import EtablissementNumero from '@/extend/controls/etablissement/EtablissementNumero';
  import EtablissementPaymentAutoSalaire from '@/extend/controls/etablissement/EtablissementPaymentAutoSalaire';
  import EtablissementPoleEmploiAdhesion from '@/extend/controls/etablissement/EtablissementPoleEmploiAdhesion';
  import EtablissementPoleEmploiAffiliation from '@/extend/controls/etablissement/EtablissementPoleEmploiAffiliation';
  import EtablissementPoleEmploiIdentifiant from '@/extend/controls/etablissement/EtablissementPoleEmploiIdentifiant';
  import EtablissementSiret from '@/extend/controls/etablissement/EtablissementSiret';
  import EtablissementSoumisTva from '@/extend/controls/etablissement/EtablissementSoumisTva';
  import EtablissementStatutLicenceSpectacle from '@/extend/controls/etablissement/EtablissementStatutLicenceSpectacle';
  import EtablissementT1790 from '@/extend/controls/etablissement/EtablissementT1790';
  import EtablissementT3252 from '@/extend/controls/etablissement/EtablissementT3252';
  import EtablissementUrssaf from '@/extend/controls/etablissement/EtablissementUrssaf';
  import EtablissementUserDisabled from '@/extend/controls/etablissement/EtablissementUserDisabled';
  import EtablissementVille from '@/extend/controls/etablissement/EtablissementVille';
  import FormeJuridiqueSelect from '@/extend/controls/formeJuridique/FormeJuridiqueSelect';
  import PaymentMeansSummary from '@/extend/controls/paymentMeans/PaymentMeansSummary';
  import RibSummary from '@/extend/controls/rib/RibSummary';
  import TrancheEffectifSelect from '@/extend/controls/trancheEffectif/TrancheEffectifSelect';
  import FractionDsnEntite from '@/extend/controls/fractionDsn/FractionDsnEntite';
  import FractionDsnFraction from '@/extend/controls/fractionDsn/FractionDsnFraction';
  import FractionDsnGenre from '@/extend/controls/fractionDsn/FractionDsnGenre';
  import FractionDsnMail from '@/extend/controls/fractionDsn/FractionDsnMail';
  import FractionDsnNom from '@/extend/controls/fractionDsn/FractionDsnNom';
  import FractionDsnNumero from '@/extend/controls/fractionDsn/FractionDsnNumero';
  import FractionDsnPrenom from '@/extend/controls/fractionDsn/FractionDsnPrenom';
  import FractionDsnType from '@/extend/controls/fractionDsn/FractionDsnType';
  import AdresseSummary from '@/extend/controls/adresse/AdresseSummary';
  import LieuLabel from '@/extend/controls/lieu/LieuLabel';
  import ManualBillingDocumentAmountHt from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountHt';
  import ManualBillingDocumentAmountTtc from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountTtc';
  import ManualBillingDocumentAmountTva from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountTva';
  import ManualBillingDocumentDocumentReference from '@/extend/controls/manualBillingDocument/ManualBillingDocumentDocumentReference';
  import ManualBillingDocumentEffectiveAt from '@/extend/controls/manualBillingDocument/ManualBillingDocumentEffectiveAt';
  import ManualBillingDocumentInCart from '@/extend/controls/manualBillingDocument/ManualBillingDocumentInCart';
  import ManualBillingDocumentKind from '@/extend/controls/manualBillingDocument/ManualBillingDocumentKind';
  import ManualBillingDocumentLabel from '@/extend/controls/manualBillingDocument/ManualBillingDocumentLabel';
  import ManualBillingDocumentLedgerCode from '@/extend/controls/manualBillingDocument/ManualBillingDocumentLedgerCode';
  import ManualBillingDocumentPaymentMethod from '@/extend/controls/manualBillingDocument/ManualBillingDocumentPaymentMethod';
  import ManualBillingDocumentReference from '@/extend/controls/manualBillingDocument/ManualBillingDocumentReference';
  import ManualBillingDocumentVatRate from '@/extend/controls/manualBillingDocument/ManualBillingDocumentVatRate';
  import NumeroObjetCode from '@/extend/controls/numeroObjet/NumeroObjetCode';
  import NumeroObjetLabel from '@/extend/controls/numeroObjet/NumeroObjetLabel';
  import EtablissementSummary from '@/extend/controls/etablissement/EtablissementSummary';
  import NumeroObjetSummary from '@/extend/controls/numeroObjet/NumeroObjetSummary';
  import ProjetNom from '@/extend/controls/projet/ProjetNom';
  import PaysSelect from '@/extend/controls/pays/PaysSelect';
  import PaysSelectNat from '@/extend/controls/pays/PaysSelectNat';
  import SalarieAbattement from '@/extend/controls/salarie/SalarieAbattement';
  import SalarieAvatar from '@/extend/controls/salarie/SalarieAvatar';
  import SalarieDateHandicap from '@/extend/controls/salarie/SalarieDateHandicap';
  import SalarieDateNaissance from '@/extend/controls/salarie/SalarieDateNaissance';
  import SalarieDepartementNaissance from '@/extend/controls/salarie/SalarieDepartementNaissance';
  import SalarieFiscalite from '@/extend/controls/salarie/SalarieFiscalite';
  import SalarieIdentifiant from '@/extend/controls/salarie/SalarieIdentifiant';
  import SalarieMail from '@/extend/controls/salarie/SalarieMail';
  import SalarieNom from '@/extend/controls/salarie/SalarieNom';
  import SalarieNomNaissance from '@/extend/controls/salarie/SalarieNomNaissance';
  import SalarieNumero from '@/extend/controls/salarie/SalarieNumero';
  import SalarieNumeroCongeSpec from '@/extend/controls/salarie/SalarieNumeroCongeSpec';
  import SalarieNumeroSecu from '@/extend/controls/salarie/SalarieNumeroSecu';
  import SalariePrenom from '@/extend/controls/salarie/SalariePrenom';
  import SalariePseudo from '@/extend/controls/salarie/SalariePseudo';
  import SalarieStatutHandicap from '@/extend/controls/salarie/SalarieStatutHandicap';
  import SalarieVilleNaissance from '@/extend/controls/salarie/SalarieVilleNaissance';
  import AdresseAdresse1 from '@/extend/controls/adresse/AdresseAdresse1';
  import AdresseAdresse2 from '@/extend/controls/adresse/AdresseAdresse2';
  import AdresseCodePostal from '@/extend/controls/adresse/AdresseCodePostal';
  import AdresseVille from '@/extend/controls/adresse/AdresseVille';
  import ContactMail from '@/extend/controls/contact/ContactMail';
  import ContactNom from '@/extend/controls/contact/ContactNom';
  import ContactNumero from '@/extend/controls/contact/ContactNumero';
  import ContactPrenom from '@/extend/controls/contact/ContactPrenom';
  import QualiteSelect from '@/extend/controls/qualite/QualiteSelect';
  import UserClient98 from '@/extend/controls/user/UserClient98';
  import UserDialog98 from '@/extend/controls/user/UserDialog98';
  import UserIdentifiant from '@/extend/controls/user/UserIdentifiant';
  import UserMail from '@/extend/controls/user/UserMail';
  import UserNom from '@/extend/controls/user/UserNom';
  import UserNumero from '@/extend/controls/user/UserNumero';
  import UserPrenom from '@/extend/controls/user/UserPrenom';
  import UserProfil from '@/extend/controls/user/UserProfil';
  import DeliveryAmount from '@/extend/controls/delivery/DeliveryAmount';
  import DeliveryCount from '@/extend/controls/delivery/DeliveryCount';
  import DeliveryReference from '@/extend/controls/delivery/DeliveryReference';
  import TransactionAmount from '@/extend/controls/transaction/TransactionAmount';
  import TransactionReference from '@/extend/controls/transaction/TransactionReference';
  import RibIban from '@/extend/controls/rib/RibIban';
  import SubscriptionTypeSelect from '@/extend/controls/subscriptionType/SubscriptionTypeSelect';

  export default defineComponent({ components: {},
    methods: {
      controls(field: any): any | null {
        if (((field.foreignTableName != null &&field.foreignTableName == 'AccidentTravails') || field.tableName == 'AccidentTravails') && field.value == 'codeRisque') {
          return AccidentTravailCodeRisque
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AccidentTravails') || field.tableName == 'AccidentTravails') && field.value == 'dateEffet') {
          return AccidentTravailDateEffet
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AccidentTravails') || field.tableName == 'AccidentTravails') && field.value == 'source') {
          return AccidentTravailSource
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AccidentTravails') || field.tableName == 'AccidentTravails') && field.value == 'tauxPatronal') {
          return AccidentTravailTauxPatronal
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AccidentTravails') || field.tableName == 'AccidentTravails') && field.value == 'type') {
          return AccidentTravailType
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Apprentis') || field.tableName == 'Apprentis') && field.value == 'dateDebut') {
          return ApprentiDateDebut
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Apprentis') || field.tableName == 'Apprentis') && field.value == 'dateFin') {
          return ApprentiDateFin
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Apprentis') || field.tableName == 'Apprentis') && field.value == 'dateRupture') {
          return ApprentiDateRupture
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Apprentis') || field.tableName == 'Apprentis') && field.value == 'nom') {
          return ApprentiNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Apprentis') || field.tableName == 'Apprentis') && field.value == 'prenom') {
          return ApprentiPrenom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Civilites') || field.tableName == 'Civilites') && field.value == 'civiliteId') {
          return CiviliteSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Attestations') || field.tableName == 'Attestations') && field.value == 'dateDemande') {
          return AttestationDateDemande
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Attestations') || field.tableName == 'Attestations') && field.value == 'dateValid') {
          return AttestationDateValid
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AttestationDefs') || field.tableName == 'AttestationDefs') && field.value == 'attestationDefId') {
          return AttestationDefSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Attestations') || field.tableName == 'Attestations') && field.value == 'motif') {
          return AttestationMotif
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Attestations') || field.tableName == 'Attestations') && field.value == 'statut') {
          return AttestationStatut
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'etablissementId') {
          return EtablissementSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AuthorizedCredits') || field.tableName == 'AuthorizedCredits') && field.value == 'creditLimit') {
          return AuthorizedCreditCreditLimit
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AuthorizedCredits') || field.tableName == 'AuthorizedCredits') && field.value == 'creditLimitUntil') {
          return AuthorizedCreditCreditLimitUntil
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'AuthorizedCredits') || field.tableName == 'AuthorizedCredits') && field.value == 'permanent') {
          return AuthorizedCreditPermanent
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contrats') || field.tableName == 'Contrats') && field.value == 'editBaseSalarie') {
          return ContratEditBaseSalarie
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contrats') || field.tableName == 'Contrats') && field.value == 'exoEtranger') {
          return ContratExoEtranger
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ContratTemplates') || field.tableName == 'ContratTemplates') && field.value == 'contratTemplateId') {
          return ContratTemplateSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Conventions') || field.tableName == 'Conventions') && field.value == 'conventionAppliqueeId') {
          return ConventionClauseMiroir
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Emplois') || field.tableName == 'Emplois') && field.value == 'emploiId') {
          return EmploiSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Rubriques') || field.tableName == 'Rubriques') && field.value == 'id') {
          return RubriqueSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'salarieId') {
          return SalarieSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ContratTemplates') || field.tableName == 'ContratTemplates') && field.value == 'active') {
          return ContratTemplateActive
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ContratTemplates') || field.tableName == 'ContratTemplates') && field.value == 'name') {
          return ContratTemplateName
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ContratTemplates') || field.tableName == 'ContratTemplates') && field.value == 'titre') {
          return ContratTemplateTitre
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ContratTemplates') || field.tableName == 'ContratTemplates') && field.value == 'useConvention') {
          return ContratTemplateUseConvention
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Activites') || field.tableName == 'Activites') && field.value == 'activiteId') {
          return ActiviteSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Creneaux') || field.tableName == 'Creneaux') && field.value == 'date') {
          return CreneauDate
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Creneaux') || field.tableName == 'Creneaux') && field.value == 'heureDebut') {
          return CreneauHeureDebut
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Creneaux') || field.tableName == 'Creneaux') && field.value == 'heureFin') {
          return CreneauHeureFin
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Lieux') || field.tableName == 'Lieux') && field.value == 'lieuId') {
          return LieuSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Branches') || field.tableName == 'Branches') && field.value == 'brancheId') {
          return BrancheSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Caisses') || field.tableName == 'Caisses') && field.value == 'retraiteComplementaireId') {
          return CaisseSelectComplementaire
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'commercialId') {
          return ContactSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'representantId') {
          return ContactSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Conventions') || field.tableName == 'Conventions') && field.value == 'conventionId') {
          return ConventionBrancheList
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'accordCollectif') {
          return EtablissementAccordCollectif
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'alias') {
          return EtablissementAlias
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'brancheCode') {
          return EtablissementBrancheCode
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'brancheNom') {
          return EtablissementBrancheNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'congesSpec') {
          return EtablissementCongesSpec
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'conventionCode') {
          return EtablissementConventionCode
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'conventionNom') {
          return EtablissementConventionNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'dateCreation') {
          return EtablissementDateCreation
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'fcap') {
          return EtablissementFcap
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'fnas') {
          return EtablissementFnas
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'identAssociation') {
          return EtablissementIdentAssociation
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'licenceSpectacle') {
          return EtablissementLicenceSpectacle
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'licenceStatus') {
          return EtablissementLicenceStatus
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'licenceValidite') {
          return EtablissementLicenceValidite
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'logo') {
          return EtablissementLogo
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'mail') {
          return EtablissementMail
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'modeFacture') {
          return EtablissementModeFacture
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'nom') {
          return EtablissementNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'numero') {
          return EtablissementNumero
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'paymentAutoSalaire') {
          return EtablissementPaymentAutoSalaire
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'poleEmploiAdhesion') {
          return EtablissementPoleEmploiAdhesion
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'poleEmploiAffiliation') {
          return EtablissementPoleEmploiAffiliation
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'poleEmploiIdentifiant') {
          return EtablissementPoleEmploiIdentifiant
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'siret') {
          return EtablissementSiret
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'soumisTva') {
          return EtablissementSoumisTva
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'statutLicenceSpectacle') {
          return EtablissementStatutLicenceSpectacle
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 't1790') {
          return EtablissementT1790
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 't3252') {
          return EtablissementT3252
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'urssaf') {
          return EtablissementUrssaf
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'userDisabled') {
          return EtablissementUserDisabled
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'ville') {
          return EtablissementVille
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FormeJuridiques') || field.tableName == 'FormeJuridiques') && field.value == 'formeJuridiqueId') {
          return FormeJuridiqueSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'PaymentMeans') || field.tableName == 'PaymentMeans') && field.value == 'salaireMeansId') {
          return PaymentMeansSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Ribs') || field.tableName == 'Ribs') && field.value == 'prelevRibId') {
          return RibSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'TrancheEffectifs') || field.tableName == 'TrancheEffectifs') && field.value == 'trancheEffectifId') {
          return TrancheEffectifSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'entite') {
          return FractionDsnEntite
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'fraction') {
          return FractionDsnFraction
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'genre') {
          return FractionDsnGenre
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'mail') {
          return FractionDsnMail
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'nom') {
          return FractionDsnNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'numero') {
          return FractionDsnNumero
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'prenom') {
          return FractionDsnPrenom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'FractionDsns') || field.tableName == 'FractionDsns') && field.value == 'type') {
          return FractionDsnType
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Adresses') || field.tableName == 'Adresses') && field.value == 'adresseId') {
          return AdresseSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Lieux') || field.tableName == 'Lieux') && field.value == 'label') {
          return LieuLabel
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'amountHt') {
          return ManualBillingDocumentAmountHt
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'amountTtc') {
          return ManualBillingDocumentAmountTtc
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'amountTva') {
          return ManualBillingDocumentAmountTva
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'documentReference') {
          return ManualBillingDocumentDocumentReference
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'effectiveAt') {
          return ManualBillingDocumentEffectiveAt
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'inCart') {
          return ManualBillingDocumentInCart
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'kind') {
          return ManualBillingDocumentKind
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'label') {
          return ManualBillingDocumentLabel
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'ledgerCode') {
          return ManualBillingDocumentLedgerCode
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'paymentMethod') {
          return ManualBillingDocumentPaymentMethod
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'reference') {
          return ManualBillingDocumentReference
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'ManualBillingDocuments') || field.tableName == 'ManualBillingDocuments') && field.value == 'vatRate') {
          return ManualBillingDocumentVatRate
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'NumeroObjets') || field.tableName == 'NumeroObjets') && field.value == 'code') {
          return NumeroObjetCode
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'NumeroObjets') || field.tableName == 'NumeroObjets') && field.value == 'label') {
          return NumeroObjetLabel
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Etablissements') || field.tableName == 'Etablissements') && field.value == 'etablissementId') {
          return EtablissementSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'NumeroObjets') || field.tableName == 'NumeroObjets') && field.value == 'numeroObjetId') {
          return NumeroObjetSummary
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Projets') || field.tableName == 'Projets') && field.value == 'nom') {
          return ProjetNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Pays') || field.tableName == 'Pays') && field.value == 'paysNaissanceId') {
          return PaysSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Pays') || field.tableName == 'Pays') && field.value == 'paysNationaliteId') {
          return PaysSelectNat
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'abattement') {
          return SalarieAbattement
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'avatar') {
          return SalarieAvatar
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'dateHandicap') {
          return SalarieDateHandicap
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'dateNaissance') {
          return SalarieDateNaissance
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'departementNaissance') {
          return SalarieDepartementNaissance
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'fiscalite') {
          return SalarieFiscalite
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'identifiant') {
          return SalarieIdentifiant
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'mail') {
          return SalarieMail
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'nom') {
          return SalarieNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'nomNaissance') {
          return SalarieNomNaissance
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'numero') {
          return SalarieNumero
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'numeroCongeSpec') {
          return SalarieNumeroCongeSpec
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'numeroSecu') {
          return SalarieNumeroSecu
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'prenom') {
          return SalariePrenom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'pseudo') {
          return SalariePseudo
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'statutHandicap') {
          return SalarieStatutHandicap
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Salaries') || field.tableName == 'Salaries') && field.value == 'villeNaissance') {
          return SalarieVilleNaissance
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Adresses') || field.tableName == 'Adresses') && field.value == 'adresse1') {
          return AdresseAdresse1
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Adresses') || field.tableName == 'Adresses') && field.value == 'adresse2') {
          return AdresseAdresse2
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Adresses') || field.tableName == 'Adresses') && field.value == 'codePostal') {
          return AdresseCodePostal
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Adresses') || field.tableName == 'Adresses') && field.value == 'ville') {
          return AdresseVille
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'mail') {
          return ContactMail
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'nom') {
          return ContactNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'numero') {
          return ContactNumero
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Contacts') || field.tableName == 'Contacts') && field.value == 'prenom') {
          return ContactPrenom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Qualites') || field.tableName == 'Qualites') && field.value == 'qualiteId') {
          return QualiteSelect
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'client98') {
          return UserClient98
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'dialog98') {
          return UserDialog98
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'identifiant') {
          return UserIdentifiant
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'mail') {
          return UserMail
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'nom') {
          return UserNom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'numero') {
          return UserNumero
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'prenom') {
          return UserPrenom
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Users') || field.tableName == 'Users') && field.value == 'profil') {
          return UserProfil
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Deliveries') || field.tableName == 'Deliveries') && field.value == 'amount') {
          return DeliveryAmount
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Deliveries') || field.tableName == 'Deliveries') && field.value == 'count') {
          return DeliveryCount
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Deliveries') || field.tableName == 'Deliveries') && field.value == 'reference') {
          return DeliveryReference
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Transactions') || field.tableName == 'Transactions') && field.value == 'amount') {
          return TransactionAmount
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Transactions') || field.tableName == 'Transactions') && field.value == 'reference') {
          return TransactionReference
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'Ribs') || field.tableName == 'Ribs') && field.value == 'iban') {
          return RibIban
        }
        if (((field.foreignTableName != null &&field.foreignTableName == 'SubscriptionTypes') || field.tableName == 'SubscriptionTypes') && field.value == 'subscriptionTypeId') {
          return SubscriptionTypeSelect
        }
        return null
      }
    }
  })
</script>
